'use client'

import { useEffect } from 'react'
import { useThemeStore } from '@/lib/stores/theme-store'
import { getFaviconFromConfig } from '@/lib/theme-helpers'

/**
 * Component to dynamically update the favicon based on the current theme
 */
export function DynamicFavicon() {
  const { currentTheme } = useThemeStore()

  useEffect(() => {
    if (typeof window === 'undefined') return

    const faviconUrl = getFaviconFromConfig(currentTheme ?? undefined)

    if (faviconUrl) {
      // Update existing favicon or create new one
      let link = document.querySelector("link[rel*='icon']") as HTMLLinkElement

      if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.head.appendChild(link)
      }

      link.href = faviconUrl

      // Also update apple-touch-icon if it exists
      const appleTouchIcon = document.querySelector("link[rel='apple-touch-icon']") as HTMLLinkElement
      if (appleTouchIcon) {
        appleTouchIcon.href = faviconUrl
      }
    }
  }, [currentTheme])

  return null
}

